import { render } from "./App.vue?vue&type=template&id=e4383384&bindings={\"showAnnouncement\":\"data\",\"navigation\":\"setup-maybe-ref\",\"whatWeDo\":\"setup-maybe-ref\",\"footer\":\"setup-maybe-ref\",\"hideAnnouncement\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
script.render = render

export default script